import { Password } from "primereact/password";
import { number } from "yup";
import { IUserMast } from "./UserMast";

export const EmptyUser: IUserMast = {
  user_EmailID: "",
  added_By: null,
  created_On: null,
  login_Name: "",
  branch:null,
  company:null,

};
